import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures submit performance
 * @param {number} perf
 */
export function captureSubmitPerformance(perf) {
  const perfThreshold = 5000
  if (perf < perfThreshold) {
    return
  }

  captureEvent('form-submit-slow', {
    duration_ms: Math.round(perf),
    threshold_ms: perfThreshold,
  })
}
